<template>
  <SAIStickyPageTabs
    :disable="disableNavigation"
    class="print-hide"
    :value="currentTab"
    :tabs="Object.values(tabs)"
    @input="tabSelected"
    single-column-desktop-width
  />
</template>

<script>
import { SAIStickyPageTabs } from 'ecx.saigon.ui.common';
import { mapGetters, mapState } from 'vuex';
import getValidRote from '../../utils/get-valid-route';

export default {
  name: 'CarSearchTabsWidget',
  data() {
    return {
      routeTabs: {}
    };
  },
  computed: {
    ...mapState({
      disableNavigation: (state) => state.ui.disableNavigation
    }),
    ...mapGetters('application', ['isApplicationStarted']),
    currentTab: function () {
      if (
        !this.$router.currentRoute ||
        !this.routeTabs[this.$router.currentRoute.name]
      ) {
        return undefined;
      }
      return this.routeTabs[this.$router.currentRoute.name].name;
    },
    tabs() {
      const budgetName = 'budget';
      return {
        calculator: {
          name: 'calculator',
          label: 'Finance Repayments',
          to: this.$RouteNames.calculator,
          progress: 100
        },
        budget: {
          name: budgetName,
          label: 'Running Cost Savings',
          disable: !this.isApplicationStarted && this.currentTab !== budgetName,
          to: this.$RouteNames.budget,
          progress:
            this.isApplicationStarted || this.currentTab === budgetName
              ? 100
              : 0
        }
      };
    }
  },
  methods: {
    tabSelected(tab) {
      let route = getValidRote(this.tabs[tab].to);
      if (route !== this.$router.currentRoute.name) {
        this.$router.push({
          name: route,
          params: { ...this.$router.currentRoute.params }
        });
      }
    }
  },
  beforeMount() {
    this.routeTabs = {
      [this.$RouteNames.calculator]: this.tabs.calculator,
      [this.$RouteNames.budget]: this.tabs.budget
    };
  },
  components: {
    SAIStickyPageTabs
  }
};
</script>
